import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';
import { Button } from '@/ui';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.DARK_ONYX} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;
